import { ApiClient } from 'lib/api/ApiClient.types';
import { parseWithDecoratedError } from 'v4/entities/common/parseWithDecoratedError';
import { z } from 'zod';
import { IntegrationApi } from './integration.api';

const integrations$ = z.object({
  data: z.array(z.object({ id: z.string(), enabled: z.boolean() }))
});

export function createIntegrationApi(client: ApiClient): IntegrationApi {
  return {
    getIntegrations: async () => {
      const response = await client.get('/integrations', { token: true });
      return parseWithDecoratedError(integrations$, response).data;
    }
  };
}
